import { render, staticRenderFns } from "./MentionPicker.vue?vue&type=template&id=04fd0dd2&scoped=true"
import script from "./MentionPicker.vue?vue&type=script&lang=js"
export * from "./MentionPicker.vue?vue&type=script&lang=js"
import style0 from "./MentionPicker.vue?vue&type=style&index=0&id=04fd0dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd0dd2",
  null
  
)

export default component.exports